<template>
  <div class="offer-expanded-details">
    <div
      v-if="item.bidderInfo"
      class="offer-expanded-details_item"
      data-qa="member">
      <div class="font-size-14 my-2 text-left bold">
        {{ $t(`Tenders.Member`) }}
      </div>
      <div
        class="text-start"
        data-qa="bidder-info-organizationName">
        {{ item.bidderInfo && item.bidderInfo.organizationName ? item.bidderInfo.organizationName : '–' }}
      </div>
      <div class="list secondary__green_chosen pa-0">
        <KeyValue
          :caption="$t('Tenders.EDRPOU')"
          class="py-2"
          data-qa="bidder-info-usreou">
          <span
            class="text-decoration-underline"
            data-qa="bidder-info">
            {{ item.bidderInfo ? item.bidderInfo.usreou ? item.bidderInfo.usreou.trim() : '–' : '–' }}
          </span>
          <sButton
            v-if="item.bidderInfo && item.bidderInfo.usreou"
            class="ml-2"
            data-qa="btn-bidder-info"
            icon="draft"
            icon-size="16px"
            small
            type="text"
            @click="$_copyUsreou(item)"/>
        </KeyValue>
        <KeyValue
          :caption="bigFirstLetter($t(`Tenders.ContactPerson`))"
          class="py-2"
          data-qa="bidder-info-fullName">
          <div
            data-qa="bidder-info-fullName">
            {{ item.bidderInfo && item.bidderInfo.fullName ? item.bidderInfo.fullName : '–' }}
          </div>
          <div
            class="h8-text opacity-5"
            data-qa="bidder-info-subtitle">
            <div data-qa="item-bidderInfo-email">
              {{ item.bidderInfo && item.bidderInfo.email ? item.bidderInfo.email : '–' }}
            </div>
            <div data-qa="item-bidderInfo-phoneNumber">
              {{ item.bidderInfo && item.bidderInfo.phoneNumber ? item.bidderInfo.phoneNumber : '–' }}
            </div>
          </div>
        </KeyValue>
        <VerificationResultBlock
          v-if="item.verification || item.bidderInfo"
          :comment="item.verification && item.verification.comment ? item.verification.comment : item.bidderInfo.comment"
          data-qa="bidder-info"
          :decision-type="item.verification && item.verification.decisionType ? item.verification.decisionType : item.bidderInfo.verificationDecision"
          :verification-status="item.verification && item.verification.verificationStatus ? item.verification.verificationStatus : item.bidderInfo.verificationStatus"/>
      </div>
    </div>
    <OffersCriterasInfo
      class="offer-expanded-details_item"
      data-qa="criteras"
      :items="item.all_criteria"
      :options="criteriaOptions"/>
    <div
      class="offer-expanded-details_item"
      data-qa="other-info">
      <div class="font-size-14 my-2 text-left bold">
        {{ $t(`Tenders.OtherInfo`) }}
      </div>
      <KeyValue
        :caption="$t('Tenders.ProposalSubmissionDate')"
        class="py-2"
        data-qa="time-supply-bids"
        :value="formattedDate"/>
      <KeyValue
        v-if="item.additionalInfo"
        :caption="$t('Tenders.AdditionalInfoLot')"
        class="py-2"
        data-qa="additional-info"
        :value="item.additionalInfo || '–'"/>
      <KeyValue
        :caption="$t('Tenders.AdditionalInfoTEnder')"
        class="py-2"
        data-qa="remark"
        :value="item.remark || '–'"/>
      <KeyValue
        v-if="item.prequalification && (item.prequalification.status == 'CANCELED' || item.prequalification.status == 'UNSUCCESSFULL')"
        :caption="$t('Tenders.ReasonForRejection')"
        class="py-2"
        data-qa="reason"
        :value="item.prequalification.reason || '–'"/>
      <KeyValue
        v-if="['CANCELED', 'CANCELED_BY_ORGANIZER'].includes(item.bidStatus) && item.cancelationReason"
        :caption="$t(`Tenders.BidCancellationReason.${item.bidStatus}`)"
        class="py-2"
        data-qa="reason"
        :value="item.cancelationReason || '–'"/>
      <OfferAccreditationBadges
        v-if="accreditationStatuses.length"
        class="py-2"
        :statuses="accreditationStatuses"/>
    </div>
    <div
      v-if="item.attachmentCount || (showContracts && item.contractCount && item.contractCount.contract)"
      class="offer-expanded-details_item"
      data-qa="attachments">
      <div v-if="item.attachmentCount">
        <div
          v-once
          class="font-size-14 my-2 text-left bold">
          {{ bigFirstLetter($t(`Tenders.Documents`)) }}
        </div>
        <DocumentList
          :attachments="item.attachments"
          color="secondary__green_chosen"
          data-qa="offer-document-list"
          small/>
      </div>
      <div v-if="showContracts && item.contractCount && item.contractCount.contract">
        <div class="h7-text-medium black--text flex align-center pt-2 mb-2 bold">
          {{ $t('Menu.Contracting') }}
        </div>
        <ContractDocuments
          :items="item.contract"/>
      </div>
      <div v-if="showContracts && item.contractCount && item.contractCount.approving">
        <div class="h7-text-medium black--text flex align-center pt-2 mb-2 bold">
          {{ $t('Tenders.AdditionalAgreements') }}
        </div>
        <ContractDocuments
          :items="item.approving"/>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import KeyValue from 'components/common/KeyValue.vue'
import DocumentList from 'components/common/blocks/DocumentList.vue'
import ContractDocuments from 'components/common/blocks/ContractDocuments.vue'
import VerificationResultBlock from 'components/supplies/VerificationResultBlock.vue'
import OffersCriterasInfo from 'components/tenders/tender page/offersGroups/OffersCriterasInfo.vue'
import OfferAccreditationBadges from 'components/tenders/tender page/offersGroups/OfferAccreditationBadges.vue'

import { tenderMixin } from 'mixins'

const MAX_CATEGORY_IDS = 6

export default {
  name: 'offerExpandedDetails',
  mixins: [tenderMixin],
  data() {
    return {
      accreditationStatuses: [],
    }
  },
  methods: {
    bigFirstLetter(element) {
      return (element[0]?.toUpperCase() || '') + element?.slice(1)?.toLowerCase() || ''
    },
    async getAccreditationStatuses() {
      const supplierId = this.item.bidderInfo?.organizationId
      if (!supplierId || !this.tender) { return }

      const categoryIds = [this.tender.category?.code, ...(this.tender.additionalCategories || []).map(el => el.code)]
        .filter(code => code != null)
      if (!categoryIds.length || categoryIds.length > MAX_CATEGORY_IDS) { return }

      this.accreditationStatuses = await this.$store.dispatch('offerAccreditationStore/fetchAccreditationStatuses', {
        tenderId: this.tender.tenderId,
        supplierId,
        categoryIds,
      })
    },
  },
  computed: {
    formattedDate() {
      if (!this.item.timeSupplyBids) { return '–' }
      return moment(this.item.timeSupplyBids).format('DD.MM.YYYY, HH:mm')
    },
  },
  components: {
    KeyValue,
    DocumentList,
    ContractDocuments,
    OffersCriterasInfo,
    VerificationResultBlock,
    OfferAccreditationBadges,
  },
  created() {
    this.getAccreditationStatuses()
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    tender: {
      type: Object,
      default: () => null,
    },
    criteriaOptions: {
      type: Object,
      default: () => ({}),
    },
    showContracts: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
<style scoped lang="scss">
.offer-expanded-details {
  display: flex;
  gap: 14px;
  justify-content: flex-start;
  &_item {
    margin-bottom: 8px;
    flex-basis: 0;
    flex-grow: 1;
  }
}
</style>
